import { Heading } from 'lucide-react';
import * as React from 'react';

import { useSelector } from 'react-redux';
import ButtonComponent from '../../../../components/UI/Button/Button.component';
import type { TextBlock } from '../../../../interfaces/textEditor.interface';
import { HeadingInput } from '../../HeadingInput';

export const CaseHeading = (props: {
  onClick: (e: any) => void;
  headingMenuAnchors: { [p: string]: HTMLElement | null };
  block: TextBlock;
  onClose: () => void;
  callbackFn: (level: number) => React.JSX.Element;
  values: any;
  index: number;
  onChange: (value: any) => void;
}) => {
  const { index } = props;
  const { isEditingDraft, isAddingPostReplyAsDraft } = useSelector(
    (state: any) => state.draftStore,
  );
  const { isEditingPostReplyDraft } = useSelector(
    (state: any) => state.postReplyDraftStore,
  );
  const isMenuOpen = Boolean(props.headingMenuAnchors[props.block.id]);
  // TRIL-258: reply composer = editing an existing reply draft OR adding a new
  // one (the "Create Draft" reply modal). Both lock the heading to H3.
  const isReplyComposer = isEditingPostReplyDraft || isAddingPostReplyAsDraft;

  const isEditing = isEditingDraft || isEditingPostReplyDraft;
  const currentValues = isEditing ? props.values.blocks : props.values;
  // TRIL-258: replies are locked to H3 as the only title heading.
  const level = isReplyComposer ? 3 : currentValues?.[index]?.data?.level || 1;
  const headerValue = currentValues?.[index]?.data?.header || '';

  return (
    <div className="heading-block">
      {/* TRIL-258: replies have no heading-level picker — locked to H3 */}
      {!isReplyComposer && (
        <div className="heading-block__control">
          <ButtonComponent
            iconButton
            size="sm"
            variant="saphir"
            aria-controls={
              props.headingMenuAnchors[props.block.id]
                ? `heading-menu-${props.block.id}`
                : undefined
            }
            aria-expanded={isMenuOpen}
            aria-haspopup="true"
            onClick={props.onClick}
          >
            <Heading size={16} />
          </ButtonComponent>
          {isMenuOpen && (
            <div
              id={`heading-menu-${props.block.id}`}
              role="menu"
              className="Case__Heading__Menu__Dropdown"
            >
              {[1, 2, 3, 4, 5, 6].map(props.callbackFn)}
            </div>
          )}
        </div>
      )}
      <div className="heading-block__input">
        <HeadingInput
          level={level}
          value={headerValue}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
};
